import { useState } from 'react'
import { Image, FileCode } from 'lucide-react'
import { buildGraphLayout } from './knowledgeMapUtils'
import { generateGraphSVG, exportAsPNG, exportAsSVG } from '../../utils/graphSvgExport'
import { createLogger } from '../../utils/logger'

const logger = createLogger('KnowledgeMapExport')

export default function KnowledgeMapExport({ testType, nodes, userName }) {
  const [exporting, setExporting] = useState(false)

  const doExport = async (format) => {
    setExporting(true)
    try {
      const { flowNodes, flowEdges, groupNodes } = await buildGraphLayout(nodes)
      if (!flowNodes.length) {
        logger.warn('No nodes to export')
        setExporting(false)
        return
      }

      const mastered = nodes
        .filter((n) => n.mastery?.status === 'MASTERED')
        .sort((a, b) => (b.mastery?.score || 0) - (a.mastery?.score || 0))
        .slice(0, 3)
        .map((n) => n.skill)

      const struggling = nodes
        .filter((n) => ['STRUGGLING', 'IN_PROGRESS'].includes(n.mastery?.status))
        .sort((a, b) => (a.mastery?.score || 0) - (b.mastery?.score || 0))
        .slice(0, 3)
        .map((n) => n.skill)

      const svgString = generateGraphSVG(flowNodes, flowEdges, groupNodes, {
        mode: 'student',
        title: `Knowledge Map — SAT ${testType === 'math' ? 'Math' : 'Reading & Writing'}`,
        subtitle: `${userName || 'Student'} • ${new Date().toLocaleDateString()}`,
        strengths: mastered,
        focusAreas: struggling
      })

      const filename = `knowledge-map-${testType}-${new Date().toISOString().slice(0, 10)}`

      if (format === 'svg') {
        exportAsSVG(svgString, `${filename}.svg`)
      } else {
        await exportAsPNG(svgString, 2, `${filename}.png`)
      }
    } catch (err) {
      logger.error('Export failed:', err)
    } finally {
      setExporting(false)
    }
  }

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => doExport('png')}
        disabled={exporting}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border rounded-lg hover:bg-gray-50 disabled:opacity-50"
      >
        <Image className="w-4 h-4" />
        {exporting ? 'Exporting...' : 'PNG'}
      </button>
      <button
        onClick={() => doExport('svg')}
        disabled={exporting}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm bg-white border rounded-lg hover:bg-gray-50 disabled:opacity-50"
      >
        <FileCode className="w-4 h-4" />
        SVG
      </button>
    </div>
  )
}
